import { protectedGet, protectedPost, protectedDeleteWithBody } from "./restUtil";
import * as _ from "underscore";

export function fetchLibraryByTag(args, onSuccess, onError) {
  return protectedGet(
    "/tag/" + args.id + "/library",
    {
      page: args.page,
      size: args.size,
    },
    resp => {
      if (!resp || resp.list === undefined) {
        return onError && onError("invalid response structure");
      }
      return onSuccess && onSuccess(resp);
    },
    onError
  );
}

export function fetchExercisesByTag(args, onSuccess, onError) {
  return protectedGet(
    "/tag/" + args.id + "/exercises",
    {
      page: args.page,
      size: args.size,
    },
    resp => {
      if (!resp || resp.list === undefined) {
        return onError && onError("invalid response structure");
      }
      return onSuccess && onSuccess(resp);
    },
    onError
  );
}

export function fetchTags(args, onSuccess, onError) {
  return protectedGet(
    "/tags",
    args,
    resp => {
      if (!resp || resp.list === undefined) {
        return onError && onError("invalid response structure");
      }
      return onSuccess && onSuccess(resp);
    },
    onError
  );
}

export function fetchTagsByCategory(category) {
  return function _fetchTagsByCategory(args, onSuccess, onError) {
    args.category = category;
    fetchTags(args, onSuccess, onError);
  };
}

export function addTagToContent(args, onSuccess, onError) {
  return protectedPost("/tag/content", args, onSuccess, onError);
}

export function deleteTagFromContent(args, onSuccess, onError) {
  return protectedDeleteWithBody("/tag/content", args, onSuccess, onError);
}

// TODO should we ask server to return 'popular' tags instead?
const RECENT_TAGS_NAME = "Talaera_recent_tags";
const RECENT_TAGS_NUMBER_OF_ITEMS = 5;

export function addItemToRecentTags(item) {
  let recentTags = getRecentTags();

  let itemIndex = _.findIndex(recentTags, tag => tag.id === item.id);
  if (itemIndex > -1) {
    // If the item is already in recent tags, then just move the item to the top.
    // Note that `splice` has the following syntax splice(index, howmany, el1, /*...,*/ elN), where
    // - `index` is the position in the array you want to start removing elements from,
    // - `howmany` is how many elements you want to remove from index,
    // - `el1`, ..., `elN` are elements you want to insert from position index.
    // It also returns removed elements.
    recentTags.splice(0, 0, recentTags.splice(itemIndex, 1)[0]);
  } else {
    if (recentTags.length > RECENT_TAGS_NUMBER_OF_ITEMS - 1) {
      recentTags = _.first(recentTags, RECENT_TAGS_NUMBER_OF_ITEMS - 1);
    }
    recentTags.unshift({
      id: item.id,
      name: item.name,
    });
  }

  localStorage.setItem(RECENT_TAGS_NAME, JSON.stringify(recentTags));
  return recentTags;
}

export function getRecentTags() {
  const recentTags = localStorage.getItem(RECENT_TAGS_NAME);
  return recentTags ? JSON.parse(recentTags) : [];
}

export const USER_LEVEL_TAG_CATEGORY = "level";
export const USER_SKILLS_TAG_CATEGORY = "teaching_skills";
export const USER_JOB_TAG_CATEGORY = "job_category";
export const USER_MANAGEMENT_TAG_CATEGORY = "management_level";
export const USER_INDUSTRY_TAG_CATEGORY = "industry";

export function findSelectedTagIdByCategory(tags, categoryName) {
  return tags.find(({ category }) => category === categoryName)?.id;
}

export function getTagsByCategory(tags, searchCategory) {
  return tags
    .filter(({ category }) => category === searchCategory)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
}
